export const articles = [
  {
    id: 1,
    slug: 'how-to-enforce-contracts-in-turkey',
    title: 'Türkiye\'de Sözleşmelerin İcrası: Kapsamlı Rehber',
    excerpt: 'Türkiye\'de ticari sözleşmelerin icra edilmesi sürecinde dikkat edilmesi gereken hukuki prosedürler, icra takibi yöntemleri ve alternatif uyuşmazlık çözüm mekanizmaları hakkında detaylı bilgiler.',
    category: 'Sözleşme Hukuku',
    author: 'Av. Can Özkan',
    date: '2025-01-15',
    readTime: '8 dakika',
    image: 'https://public.readdy.ai/ai/img_res/bd9bef7b04da3f07d7a1adc77468d407.jpg',
    content: `Türkiye'de ticari sözleşmelerin icrası, iş dünyasının en kritik konularından biridir. Bu makalede, sözleşme ihlali durumunda başvurulabilecek hukuki yolları, icra takibi süreçlerini ve alternatif uyuşmazlık çözüm mekanizmalarını detaylı olarak inceleyeceğiz.`,
  },
  {
    id: 2,
    slug: 'legal-risks-in-real-estate-investments',
    title: 'Gayrimenkul Yatırımlarında Hukuki Riskler ve Korunma Yolları',
    excerpt: 'Gayrimenkul yatırımlarında karşılaşılabilecek hukuki riskler, tapu inceleme süreçleri, imar durumu analizi ve yatırımcıların dikkat etmesi gereken kritik noktalar.',
    category: 'Gayrimenkul Hukuku',
    author: 'Av. Ayşe Demir',
    date: '2025-01-10',
    readTime: '10 dakika',
    image: 'https://readdy.ai/api/search-image?query=modern%20luxury%20real%20estate%20property%20with%20glass%20facade%20and%20contemporary%20architecture%20professional%20building%20exterior%20elegant%20urban%20development%20premium%20architectural%20photography%20natural%20lighting&width=800&height=500&seq=art2&orientation=landscape',
    content: `Gayrimenkul yatırımları, önemli finansal kararlar gerektiren ve dikkatli hukuki inceleme yapılması gereken alanlardır. Bu yazıda, yatırımcıların karşılaşabileceği hukuki riskleri ve bu risklerden korunma yollarını ele alacağız.`,
  },
  {
    id: 3,
    slug: 'what-foreign-investors-should-know-about-turkish-law',
    title: 'Yabancı Yatırımcıların Türk Hukuku Hakkında Bilmesi Gerekenler',
    excerpt: 'Türkiye\'de yatırım yapmak isteyen yabancı yatırımcılar için şirket kuruluşu, vergi düzenlemeleri, çalışma izinleri ve yatırım teşvikleri hakkında kapsamlı bilgiler.',
    category: 'Yatırım Hukuku',
    author: 'Av. Mehmet Yılmaz',
    date: '2025-01-05',
    readTime: '12 dakika',
    image: 'https://readdy.ai/api/search-image?query=international%20business%20meeting%20with%20world%20map%20and%20global%20investment%20documents%20professional%20corporate%20office%20modern%20conference%20room%20premium%20business%20photography%20natural%20lighting&width=800&height=500&seq=art3&orientation=landscape',
    content: `Türkiye, stratejik konumu ve büyüyen ekonomisiyle yabancı yatırımcılar için cazip bir pazar olmaya devam ediyor. Bu makalede, yabancı yatırımcıların Türkiye'de yatırım yaparken bilmesi gereken temel hukuki konuları ele alacağız.`,
  },
  {
    id: 4,
    slug: 'commercial-disputes-in-turkey',
    title: 'Türkiye\'de Ticari Uyuşmazlıklar ve Çözüm Yolları',
    excerpt: 'Ticari uyuşmazlıkların çözümünde mahkeme süreci, tahkim, arabuluculuk ve diğer alternatif uyuşmazlık çözüm yöntemlerinin karşılaştırmalı analizi.',
    category: 'Ticari Dava',
    author: 'Av. Can Özkan',
    date: '2024-12-28',
    readTime: '9 dakika',
    image: 'https://readdy.ai/api/search-image?query=professional%20courtroom%20interior%20with%20wooden%20panels%20and%20judges%20bench%20serious%20legal%20atmosphere%20traditional%20law%20court%20architecture%20premium%20judicial%20photography%20natural%20lighting&width=800&height=500&seq=art4&orientation=landscape',
    content: `Ticari uyuşmazlıklar, iş dünyasının kaçınılmaz bir parçasıdır. Bu yazıda, Türkiye'de ticari uyuşmazlıkların çözümünde kullanılabilecek farklı yöntemleri, avantaj ve dezavantajlarıyla birlikte inceleyeceğiz.`,
  },
  {
    id: 5,
    slug: 'how-bankruptcy-proceedings-work',
    title: 'İflas Süreçleri Nasıl İşler: Adım Adım Rehber',
    excerpt: 'İflas davası açma şartları, konkordato süreci, alacaklı hakları ve iflas masasının tasfiyesi hakkında detaylı bilgiler ve pratik öneriler.',
    category: 'İcra ve İflas Hukuku',
    author: 'Av. Mehmet Yılmaz',
    date: '2024-12-20',
    readTime: '11 dakika',
    image: 'https://readdy.ai/api/search-image?query=serious%20legal%20documents%20and%20gavel%20on%20wooden%20desk%20bankruptcy%20papers%20and%20financial%20statements%20professional%20law%20office%20setting%20premium%20legal%20photography%20natural%20lighting&width=800&height=500&seq=art5&orientation=landscape',
    content: `İflas süreçleri, hem borçlular hem de alacaklılar için karmaşık ve stresli bir dönem olabilir. Bu kapsamlı rehberde, iflas süreçlerinin nasıl işlediğini, tarafların haklarını ve dikkat edilmesi gereken noktaları ele alacağız.`,
  },
  {
    id: 6,
    slug: 'corporate-governance-best-practices',
    title: 'Kurumsal Yönetim İlkeleri ve En İyi Uygulamalar',
    excerpt: 'Şirketlerde kurumsal yönetim ilkelerinin uygulanması, yönetim kurulu yapısı, şeffaflık ve hesap verebilirlik konularında rehber niteliğinde bilgiler.',
    category: 'Kurumsal Hukuk',
    author: 'Av. Ayşe Demir',
    date: '2024-12-15',
    readTime: '10 dakika',
    image: 'https://readdy.ai/api/search-image?query=modern%20corporate%20boardroom%20with%20large%20conference%20table%20and%20executive%20chairs%20professional%20business%20meeting%20space%20elegant%20office%20interior%20premium%20corporate%20photography%20natural%20lighting&width=800&height=500&seq=art6&orientation=landscape',
    content: `Kurumsal yönetim ilkeleri, şirketlerin sürdürülebilir başarısı için kritik öneme sahiptir. Bu makalede, kurumsal yönetim ilkelerinin uygulanması ve en iyi uygulamalar hakkında detaylı bilgiler sunacağız.`,
  },
];